import type {
  HarmonyPackage,
  HarmonyPackageBoard,
  HarmonyPackageBoardColumn,
  HarmonyPackageBoardWorkitem,
  HarmonyPackageDocument,
  HarmonyWorkitem,
  Iteration,
  Team,
  TeamIntegration,
  TeamMembership,
  TeamReferenceStory,
  TeamTag,
  Workitem,
  WorkitemTag,
  WorkspaceMembership,
} from '@rhythmic/db/types'
import type { HarmonyPackageFolder } from '@rhythmic/types'

import {
  HARMONY_PACKAGE_BOARD_COLUMN_TABLE,
  HARMONY_PACKAGE_BOARD_TABLE,
  HARMONY_PACKAGE_BOARD_WORKITEM_TABLE,
  HARMONY_PACKAGE_DOCUMENT_TABLE,
  HARMONY_PACKAGE_FOLDER_TABLE,
  HARMONY_PACKAGE_TABLE,
  HARMONY_WORKITEM_TABLE,
  TEAM_INTEGRATION_TABLE,
  TEAM_ITERATION_TABLE,
  TEAM_MEMBER_TABLE,
  TEAM_TABLE,
  TEAM_TAG_TABLE,
  WORKITEM_TABLE,
  WORKITEM_TAG_TABLE,
  WORKSPACE_MEMBER_TABLE,
} from '../collections/CollectionConfigurations'
import { TEAM_REFERENCE_STORY_TABLE } from '../collections/CollectionConfigurations/TeamReferenceStoryConfig'
import { useCollection } from '../composables/useCollection'

export function getBoardsCollection(planId: string) {
  return useCollection<HarmonyPackageBoard>(HARMONY_PACKAGE_BOARD_TABLE, {
    package_id: planId,
  }).collection
}

export function getColumnsCollection(boardId: string) {
  return useCollection<HarmonyPackageBoardColumn>(HARMONY_PACKAGE_BOARD_COLUMN_TABLE, {
    board_id: boardId,
  }).collection
}

export function getTeamReferenceStoryCollection(teamId: string) {
  return useCollection<TeamReferenceStory>(TEAM_REFERENCE_STORY_TABLE, {
    team_id: teamId,
  }).collection
}

export function getBoardItemsCollection(boardId: string) {
  return useCollection<HarmonyPackageBoardWorkitem>(HARMONY_PACKAGE_BOARD_WORKITEM_TABLE, {
    board_id: boardId,
  }).collection
}

export function getHarmonyItemsCollection(harmonyPlanId: string) {
  return useCollection<HarmonyWorkitem>(HARMONY_WORKITEM_TABLE, {
    harmony_package_id: harmonyPlanId,
  }).collection
}
export function getPlanCollection(workspaceId: string) {
  return useCollection<HarmonyPackage>(HARMONY_PACKAGE_TABLE, {
    workspace_id: workspaceId,
  }).collection
}
export function getHarmonyDocumentCollection(planId: string) {
  return useCollection<HarmonyPackageDocument>(HARMONY_PACKAGE_DOCUMENT_TABLE, {
    package_id: planId,
  }).collection
}

export function getHarmonyFolderCollection(planId: string) {
  return useCollection<HarmonyPackageFolder>(HARMONY_PACKAGE_FOLDER_TABLE, {
    package_id: planId,
  }).collection
}
export function getWorkitemsCollection(teamId: string) {
  return useCollection<Workitem>(WORKITEM_TABLE, {
    team_id: teamId,
  }).collection
}

export function getWorkitemTagsCollection(teamId: string) {
  return useCollection<WorkitemTag>(WORKITEM_TAG_TABLE, {
    team_id: teamId,
  }).collection
}

export function getTeamTagsCollection(teamId: string) {
  return useCollection<TeamTag>(TEAM_TAG_TABLE, {
    team_id: teamId,
  }).collection
}

export function getTeamIntegrationsCollection(teamId: string) {
  return useCollection<TeamIntegration>(
    TEAM_INTEGRATION_TABLE,
    {
      team_id: teamId,
    },
    'query',
  ).collection
}

export function getIterationsCollection(teamId: string) {
  return useCollection<Iteration>(TEAM_ITERATION_TABLE, {
    team_id: teamId,
  }).collection
}

export function getTeamCollection(workspaceSlug: string) {
  return useCollection<Team>(TEAM_TABLE, {
    workspace_slug: workspaceSlug,
  }).collection
}

export function getTeamMembershipCollection(teamId: string) {
  return useCollection<TeamMembership>(TEAM_MEMBER_TABLE, teamId).collection
}

export function getWorkspaceMembershipCollection(workspaceId: string) {
  return useCollection<WorkspaceMembership>(WORKSPACE_MEMBER_TABLE, {
    workspace_id: workspaceId,
  }).collection
}
